import { useLoading } from '@/contexts/LoadingContext';
import { PinwheelLoader } from './PinwheelLoader';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Centralized loader component that reads from LoadingContext.
 * Render this once at the AppShell level.
 */
export function CentralLoader({ text = 'Loading' }) {
    const { showLoader, success, onAnimationComplete } = useLoading();

    return (
        <AnimatePresence>
            {showLoader && (
                <motion.div
                    className="fixed inset-0 flex items-center justify-center bg-white/95 z-50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                >
                    <PinwheelLoader
                        text={text}
                        success={success}
                        onAnimationComplete={onAnimationComplete}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
